import { render, staticRenderFns } from "./inc_person_step_5.vue?vue&type=template&id=f05318b6&"
import script from "./inc_person_step_5.vue?vue&type=script&lang=js&"
export * from "./inc_person_step_5.vue?vue&type=script&lang=js&"
import style0 from "./inc_person_step_5.vue?vue&type=style&index=0&id=f05318b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports